import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect, Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import { fetchFranchisee, createFranchisee, updateFranchisee } from './actions';
import FranchiseeSettingsForm from './SettingsForm';
import TerritoriesList from '../territories/index';
import TerritoryDetails from '../territories/Details';
import CentersList from '../centers/index';
import CenterDetails from '../centers/Details';
import TeachersList from '../teachers/index';
import TeacherDetails from '../teachers/Details';
import { withTranslation } from 'react-i18next';
import FranchiseePayments from '../payments';
import { paymentOwners } from '../payments/methods/common';
import authUtils from '../../auth/utils';
import { loadPaymentMethods } from '../payments/actions';
import queryString from 'query-string';
import Notes from '../notes';
import { Panel } from 'react-bootstrap';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleFranchiseeSettingsSubmit = this.handleFranchiseeSettingsSubmit.bind(this);
		this.handleTabSelect = this.handleTabSelect.bind(this);
	}

	componentDidMount() {
		const { match, fetchFranchisee } = this.props;
		const franchiseeId = match.params.id;

		if (franchiseeId) {
			fetchFranchisee(franchiseeId);
		}
	}

	handleTabSelect(key) {
		const { franchisee } = this.props;
		if (franchisee) {
			this.props.history.replace(`/franchisees/${franchisee.id}/${key}`);
		}
	}

	handleFranchiseeSettingsSubmit(values) {
		const { franchisee, createFranchisee, updateFranchisee, history } = this.props;

		if (franchisee) {
			updateFranchisee(franchisee.id, values);
		} else {
			createFranchisee(values, history);
		}
	}

	render() {
		const { match, franchisee, defaultTimeZone, t, currentUser, isReadonly, selectedTab, location } = this.props;
		const queryParams = queryString.parse(location.search);
		const selectedPaymentMethodName = selectedTab === 'payments' && queryParams.method;

		return (
			<div>
				<Link to='/franchisees' className='btn btn-default mb-1'>{t('Common_BackToList')}</Link>
				<Tabs defaultActiveKey={selectedTab} id='franchisee-details-tabs' onSelect={this.handleTabSelect}>
					<Tab eventKey='franchisee' title={t('Franchisee_Tab_Details')}>
						<Panel>
							<Panel.Heading>{t('Common_Details')}</Panel.Heading>
							<Panel.Body>
								<FranchiseeSettingsForm form={match.params.id ? 'franchisee' : 'newFranchisee'} onSubmit={this.handleFranchiseeSettingsSubmit} defaultTimeZone={defaultTimeZone} initialValues={franchisee} isReadonly={isReadonly} />
							</Panel.Body>
						</Panel>
					</Tab>
					{franchisee && <Tab eventKey='territories' title={t('Franchisee_Tab_Territories')}>
						<Switch>
							<Route path={`/franchisees/${franchisee.id}/territories`} exact render={props => <TerritoriesList franchiseeId={franchisee.id} />} />
							<Route path={`/franchisees/${franchisee.id}/territories/new`} render={props => <TerritoryDetails franchiseeId={franchisee.id} {...props} />} />
							<Route path={`/franchisees/${franchisee.id}/territories/:territoryId`} render={props => <TerritoryDetails franchiseeId={franchisee.id} {...props} />} />
						</Switch>
					</Tab>}
					{franchisee && <Tab eventKey='centers' title={t('Franchisee_Tab_Centers')}>
						<Switch>
							<Route path={`/franchisees/${franchisee.id}/centers`} exact render={props => <CentersList franchiseeId={franchisee.id} />} />
							<Route path={`/franchisees/${franchisee.id}/centers/new`} render={props => <CenterDetails franchisee={franchisee} {...props} />} />
							<Route path={`/franchisees/${franchisee.id}/centers/:centerId`} render={props => <CenterDetails franchisee={franchisee} {...props} />} />
						</Switch>
					</Tab>}
					{franchisee && authUtils.hasPermission(currentUser, 'PaymentConfiguration') && <Tab eventKey='payments' title={t('Franchisee_Tab_PaymentConfiguration')}>
						<FranchiseePayments ref={instance => this.temp = instance} paymentOwnerId={franchisee.id} paymentOwnerType={paymentOwners.franchisee} selectedPaymentMethodName={selectedPaymentMethodName} />
					</Tab>}
					{franchisee && <Tab eventKey='teachers' title={t('Franchisee_Tab_Teachers')}>
						<Switch>
							<Route path={`/franchisees/${franchisee.id}/teachers`} exact render={props => <TeachersList franchiseeId={franchisee.id} />} />
							<Route path={`/franchisees/${franchisee.id}/teachers/new`} render={props => <TeacherDetails franchiseeId={franchisee.id} {...props} />} />
							<Route path={`/franchisees/${franchisee.id}/teachers/:teacherId`} render={props => <TeacherDetails franchiseeId={franchisee.id} {...props} />} />
						</Switch>
					</Tab>}
					{franchisee && authUtils.hasPermission(currentUser, 'Notes') && <Tab eventKey='notes' title={t('Franchisee_Tab_Notes')}>
						<Notes reference={franchisee.id} referenceType='Franchisee' />
					</Tab>}
				</Tabs>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const franchiseeId = ownProps.match.params.id;
	const selectedTab = ownProps.match.params.tab || 'franchisee';

	const {
		auth: { currentUser },
		entities: { franchisees },
		configuration: { franchisor }
	} = state;

	return {
		franchisee: franchisees[franchiseeId],
		selectedTab,
		defaultTimeZone: franchisor.timeZone,
		currentUser,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Franchisees')
	};
};

export default connect(mapStateToProps, {
	fetchFranchisee,
	createFranchisee,
	updateFranchisee,
	loadPaymentMethods
})(withTranslation()(Details));